import axios from 'axios';
import { getCookieValues } from '../../utilities/helpers';

const [houseUserName] = getCookieValues(['HOUSEALIAS']);

// TODO: (COR-2921) houseUserName here and liveUserRef (set in thunks.js) are deprecated —
// remove both once COR-2922 (cookie auth on auctions-svc) is deployed
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  houseUserName
};

// Same-origin path: nginx proxies /api/auctions/* to auctions-svc, forwarding LiveUser cookies
const customRequest = axios.create({
  baseURL: '/api/',
  withCredentials: true,
  headers
});

// Same-origin path to the azweb app server: nginx proxies /azweb/* there directly, so
// /azweb/app/external/* reaches the same backend as {subdomain}.invaluable.com/app/external/*
// (invaluable.com's nginx rewrites /app/* to /azweb/app/* itself) with LiveUser cookies forwarded
export const customRequestApp = axios.create({
  baseURL: '/azweb/',
  withCredentials: true,
  headers: {
    ...headers,
    channel: 'infinitebidding',
  },
});

export default customRequest;
